type ClipboardData = Pick<DataTransfer, "getData"> & {
  items: ArrayLike<Pick<DataTransferItem, "getAsFile" | "kind" | "type">>
}

function clipboardHasText(dataTransfer: Pick<DataTransfer, "getData">): boolean {
  return Boolean(dataTransfer.getData("text/html") || dataTransfer.getData("text/plain"))
}

export function getClipboardImageFiles(dataTransfer: ClipboardData | null): File[] {
  if (!dataTransfer?.items.length || clipboardHasText(dataTransfer)) return []

  const files: File[] = []

  for (const item of Array.from(dataTransfer.items)) {
    if (item.kind !== "file" || !item.type.startsWith("image/")) continue

    const file = item.getAsFile()
    if (file) {
      files.push(file)
    }
  }

  return files
}
